import { WalletBalanceDTO } from "@gymflow/types";
import {
  infiniteQueryOptions,
  QueryKey,
  queryOptions,
} from "@tanstack/react-query";

import { api } from "../../api";
import { queryClient } from "../../QueryClient";
import { tokenPagination } from "../../tokenPagination";

const keys = {
  perUser: (memberId: unknown) =>
    ["memberApiWallet", "perUser", memberId] as QueryKey,
  list: (memberId: string | undefined) =>
    [...keys.perUser(memberId), "list"] as QueryKey,
  listHistory: (memberId: string | undefined, filter: unknown) =>
    [...keys.perUser(memberId), "listHistory", filter] as QueryKey,
  redeem: (memberId: string | undefined, params: unknown) =>
    [...keys.perUser(memberId), "redeem", params] as QueryKey,
};

export const memberApiWallet = {
  keys,
  queries: {
    list: (memberId: string | undefined) =>
      queryOptions({
        queryKey: keys.list(memberId),
        queryFn: async () => {
          return (await api.get<WalletBalanceDTO>("/customer/wallet-balance"))
            .data;
        },
      }),
  },
  infiniteQueries: {
    listHistory: (
      memberId: string | undefined,
      params: {
        limit?: number;
        nextPageToken?: string;
        walletTransactionTypes?: string[];
        dateFrom: string | null;
        dateTo: string | null;
      },
    ) =>
      infiniteQueryOptions({
        queryKey: keys.listHistory(memberId, params),
        queryFn: async ({ pageParam }) =>
          (
            await api.get("/customer/wallet-balance/history", {
              params: { ...params, nextPageToken: pageParam },
            })
          ).data,
        ...tokenPagination,
      }),
  },
  mutations: {
    redeem: (memberId: string | undefined) => ({
      mutationKey: keys.redeem(memberId, {}),
      mutationFn: async ({ voucherCode }: { voucherCode: string }) => {
        return (
          await api.put<{ voucherCode: string }>(
            `/customer/wallet-balance/voucher-redeem/${voucherCode}`,
          )
        ).data;
      },
      onSettled: async () =>
        await queryClient.invalidateQueries({
          queryKey: keys.perUser(memberId),
        }),
    }),
  },
};
